export class TipoPersona{

    constructor(){
        this.Codigo = 0;
        this.Nombre = "";
        this.Clase = "";
    }

    Codigo: number;
    Nombre: string;
    Clase: string;
}

export default TipoPersona;